import React from 'react';
import { TableColumn } from '../components/Table';
import { UserPoints, FormEntry } from '../api/usersApi';

/**
 * Renders the form array as colored squares showing points earned per match.
 * Colors: green = exact score, blue = winner only, gray = nothing.
 */
export const renderForm = (form: FormEntry[] | undefined): React.ReactNode => {
  if (!form || form.length === 0) {
    return <span className="text-gray-500">-</span>;
  }

  return (
    <div className="flex items-center gap-1">
      {form.map((entry, index) => {
        let bgColor = 'bg-gray-500';
        if (entry.t === 1) bgColor = 'bg-blue-500';
        else if (entry.t === 2) bgColor = 'bg-green-600';

        const title = `${entry.p}`;

        return (
          <div
            key={index}
            className={`w-2.5 h-2.5 rounded-full ${bgColor} shadow-sm`}
            title={title}
          />
        );
      })}
    </div>
  );
};

export const getFormColumn = (): TableColumn<UserPoints> => ({
  key: 'form',
  title: 'רצף',
  render: (item: UserPoints) => renderForm(item.form),
});

export const getUserPointsColumns = (): TableColumn<UserPoints>[] => [
  {
    key: 'first_name',
    title: 'שם',
    width: '40%',
    rawCell: true,
    render: (item: UserPoints) => (
      <div className="truncate ml-2 text-gray-300" title={`${item.first_name} ${item.last_name}`}>
        {item.first_name} {item.last_name}
      </div>
    ),
  },
  getFormColumn(),
  {
    key: 'points',
    title: 'נקודות',
    render: (item: UserPoints) => (
      <span className="font-semibold text-stake-blue">{item.points}</span>
    ),
  },
];

